var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 220,
    height: 144,
    rx: 16
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.6%",
    y: "-12.5%",
    width: "127.3%",
    height: "141.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdowns",
    transform: "translate(-258.000000, -366.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FAFBFC",
    x: 0,
    y: 0,
    width: 1440,
    height: 900
  }), /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(74.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#365EDE",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "selector",
    fill: "#000000",
    opacity: 0.15,
    x: 0,
    y: 52,
    width: 220,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "list/dropdown-menu-copy",
    transform: "translate(0.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 220,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u0421\\u043E\\u0442\\u0440\\u0443\\u0434\\u043D\\u0438\\u0447\\u0435\\u0441\\u0442\\u0432\\u043E",
    fontFamily: "Manrope-SemiBold, Manrope",
    fontSize: 16,
    fontWeight: 500,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20,
    y: 26
  }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 2")))), /*#__PURE__*/React.createElement("g", {
    id: "icons/misc/done",
    transform: "translate(258.000000, 366.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.891102,7.5455625 L8.91477944,14.0008125 C8.79257278,14.1335625 8.59398695,14.1335625 8.47247464,14.0008125 L7.58925373,13.0370625 C7.46774142,12.9050625 7.26846124,12.6890625 7.14764328,12.5555625 L5.09234936,10.2215625 C5.03194038,10.1563125 5,10.0640625 5,9.9763125 C5,9.8900625 5.03194038,9.8060625 5.09234936,9.7408125 L5.99292916,8.8640625 C6.05403249,8.7965625 6.13527215,8.7635625 6.21581745,8.7635625 C6.29497404,8.7643125 6.37413064,8.7980625 6.43453961,8.8640625 L8.47316899,11.1103125 C8.5946813,11.2438125 8.79326714,11.2438125 8.9154738,11.1103125 L13.566965,6.0995625 C13.6891717,5.9668125 13.8870632,5.9668125 14.0085755,6.0995625 L14.8917964,7.0633125 C15.0133087,7.1953125 15.0133087,7.4128125 14.891102,7.5455625 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.eaecc3bb.svg";
export { ForwardRef as ReactComponent };